<template lang="pug">
  .NotificationsListItemIcon.icon(v-if="iconPathName")
    BaseImage(
      v-if="type"
      force,
      :src="require(`images/icon/png-emoji/${iconPathName}.png`)",
      :alt="iconPathName",
    )
</template>

<script>

export default {
  name: 'NotificationsListItemIcon',
  props: {
    type: {
      type: String,
      default: 'welcome',
    },
    code: String,
  },
  computed: {
    typeWelcome() {
      return this.type === 'welcome';
    },
    typeVerification() {
      return this.type === 'verification';
    },
    typeCongrat() {
      return this.type === 'congrats';
    },
    typeInvestment() {
      return this.type === 'investment';
    },
    typeWallet() {
      return this.type === 'wallet';
    },
    typeDocument() {
      return this.type === 'document';
    },
    typeDistribution() {
      return this.type === 'distribution';
    },
    typeFountainPen() {
      return this.type === 'fountain-pen';
    },
    iconPathName() {
      switch (this.type) {
        case 'welcome': {
          return 'waving-hand-sign';
        }
        case 'verification':
          return 'bust-in-silhouette';
        case 'congrats':
          return 'party-popper';
        case 'document':
          if (this.code && this.code === 'farm_update_doc') return 'ear-of-rice';
          return 'page-facing-up';
        case 'wallet':
          return 'money-bag';
        case 'investment':
          return 'banknote-with-dollar-sign';
        case 'distribution':
          return 'money-with-wings';
        case 'custom_distribution':
          return 'custom-distribution';
        case 'fountain-pen':
          return 'fountain-pen';
        default:
          return this.type;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.icon
  display: flex
  img
    width: 14px
    height: 100%
</style>
